import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Mutex } from 'async-mutex';

import { authService } from 'index';
import { setToken, logout } from 'store/auth/authSlice';
import { isDevelopment } from 'utils/environment';
import { toQueryParams } from 'utils/http/params';
import { authUrl, dataUrl } from './mainUrl';

const mutex = new Mutex();

export const createBaseQueryWithReauth = ({
    baseUrl,
    timeout = 30000,
}) => {
    const baseQuery = fetchBaseQuery({
        baseUrl,
        timeout,
        responseHandler: 'content-type',
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;

            token && headers.set('authorization', `Bearer ${token}`);
            return headers;
        },
    });

    return async (args, api, extraOptions) => {
        await mutex.waitForUnlock();

        let result = await baseQuery(args, api, extraOptions);

        if (result.error?.status === 401) {
            if (!mutex.isLocked()) {
                const release = await mutex.acquire();

                try {
                    const refreshResult = await authService.refreshToken();

                    if (refreshResult?.success) {
                        api.dispatch(setToken(refreshResult.body.accessToken));
                        result = await baseQuery(args, api, extraOptions);
                    } else {
                        api.dispatch(logout());
                    }
                } catch {
                    api.dispatch(logout());
                } finally {
                    release();
                }
            } else {
                await mutex.waitForUnlock();
                result = await baseQuery(args, api, extraOptions);
            }
        }

        if (result.data?.success === false) {
            return {
                ...result,
                error: { data: result.data },
            };
        }

        return result;
    };
};

export const dataApi = createApi({
    reducerPath: 'dataApi',
    baseQuery: createBaseQueryWithReauth({
        baseUrl: dataUrl,
        timeout: 30000,
    }),
    keepUnusedDataFor: 120,
    endpoints: (builder) => ({})
});

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: createBaseQueryWithReauth({  
        baseUrl: authUrl,
        timeout: 30000,
    }),
    keepUnusedDataFor: 120,
    endpoints: (builder) => ({})
});


/*const mutex = new Mutex();

const baseDataQuery = fetchBaseQuery({ 
    baseUrl: dataUrl,
    timeout: 30000,
    responseHandler: 'content-type',
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.accessToken;
        if(token) {
            headers.set('authorization', `Bearer ${token}`);
        }
        return headers;
    }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {  
    
    // wait until the mutex is available without locking it
    await mutex.waitForUnlock();
    let result = await baseDataQuery(args, api, extraOptions);
    
    
    if (result.error && result.error.status === 401) { 
        if(!mutex.isLocked()) {
            const release = await mutex.acquire();
            try {
                const refreshResult = await authService.refreshToken();
                if(refreshResult && refreshResult.success) {
                    api.dispatch(setToken(refreshResult.body.accessToken));
                    result = await baseDataQuery(args, api, extraOptions);
                }
                else {
                    api.dispatch(logout());
                } 
            }
            catch(err) {
                api.dispatch(logout());
            }
            finally {
               // release must be called once the mutex should be released again.
                release(); 
            }
        }
        else {
            await mutex.waitForUnlock();
            result = await baseDataQuery(args, api, extraOptions);
        }
        
    } 

    
    if(result.data && result.data.success == false) { 
        return {...result, error: {data: result.data}};
    }
    
    return result;
};



export const dataApi = createApi({
    reducerPath: 'dataApi',
    baseQuery: baseQueryWithReauth,
    keepUnusedDataFor: 120,
    endpoints: (builder) => ({})
});*/
